import { InjectionToken, Type } from '@angular/core';
import { CellValueChangedEvent } from 'ag-grid-community';

export interface Handler<T = any> {
  handle(event: T, ...args: unknown[]): void;
}

export interface ValueChangeCommand {
  events: Array<number | string>;
  handler: Type<Handler<CellValueChangedEvent>>;
}

export interface HasChangeCommandHandler {
  changeEventCommand?: ValueChangeCommand;
}

export const CHANGE_EVENT_COMMAND_HANDLER = new InjectionToken<Handler<CellValueChangedEvent>>(
  'CHANGE_EVENT_COMMAND_HANDLER'
);

/**
 * Interface for providing commands for handling change events in the table.
 */
export interface AgTableEventCommandsProvider {
  setColumnsCommands?(commands: HasChangeCommandHandler[]): void;
  getColumnsCommands(): HasChangeCommandHandler[];
}

/**
 * Injection token for providing commands for handling change events in the table.
 */
export const AGTABLE_EVENT_COMMANDS_PROVIDER = new InjectionToken<AgTableEventCommandsProvider>(
  'AGTABLE_EVENT_COMMANDS_PROVIDER'
);
